import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { MasteryPreview } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { MasteryInfo, MasteryIcon, OtherActions } from './components';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, ...rest } = props;
  const model = useSelector(state => state.models.mastery);

  const classes = useStyles();

  if (!model) {
    return null;
  }

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <MasteryInfo className={classes.card} />
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <MasteryIcon className={classes.card} />
        <MasteryPreview masteryId={model.next_mastery_level_id} title="Next Mastery" />
        <OtherActions handleDelete={handleDelete} className={classes.card} />
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
